import { objectGetKeys } from '../../utils/ieCompatibility'

export enum lotCompleteTypesEnum {
	apartment = 221310000,
	celluleLogistique = 221310001,
	localCommercial = 221310002,
	localDivers = 221310003,
	localFonctionnel = 221310004,
	lotMedical = 221310005,
	parking = 221310006,
	plateau = 221310007,
	piece = 221310008
}

export enum lotCompleteCategoryEnum {
	twoPieces = 221310000,
	threePieces = 221310001,
	fourPieces = 221310002,
	fivePieces = 221310003,
	sixPieces = 221310004,
	sevenPieces = 221310005,
	auditorium = 221310006,
	shop = 221310007,
	doubleBox = 221310008,
	motoBox = 221310009,
	noRentBox = 221310010,
	smallBox = 221310011,
	simpleBox = 221310012,
	desk = 221310013,
	homeDesk = 221310014,
	cafe = 221310015,
	cave = 221310016,
	logistic = 221310017,
	bedroom = 221310018,
	bedroomService = 221310019,
	hospital = 221310020,
	concierge = 221310021,
	clearance = 221310022,
	enseigne = 221310023,
	panel = 221310024,
	phone = 221310025,
	dock = 221310026,
	hostOldDepend = 221310027,
	hostOld = 221310028,
	hostel = 221310029,
	laboratory = 221310030,
	laundromat = 221310031,
	commercialLocal = 221310032,
	activityLocal = 221310033,
	archivesLocal = 221310034,
	receptionLocal = 221310035,
	serviceLocal = 221310036,
	diversLocal = 221310037,
	functionalLocal = 221310038,
	trashLocal = 221310039,
	professionalLocal = 221310040,
	technicalLocal = 221310041,
	bicycleLocal = 221310042,
	noPatrimonialPanel = 221310043,
	doubleInternalParking = 221310044,
	parkingCouvertTripe = 221310078,
	motoInternalParking = 221310045,
	noRentInternalParking = 221310046,
	smallInternalParking = 221310047,
	simpleInternalParking = 221310048,
	doubleExternalParking = 221310049,
	noPatrimonialExternalParking = 221310050,
	noRentExternalParking = 221310051,
	simpleExternalParking = 221310052,
	bicycleParking = 221310053,
	twoPiecesPavillon = 221310054,
	fourPiecesPavillon = 221310055,
	fivePiecesPavillon = 221310056,
	sixPiecesPavillon = 221310057,
	sevenPiecesPavillon = 221310058,
	psy = 221310059,
	stock = 221310060,
	stocks = 221310061,
	restaurationInterEnterprises = 221310062,
	restaurationInter_Enterprises = 221310063,
	chillRoom = 221310064,
	meetingRoom = 221310065,
	sportRoom = 221310066,
	healthAndReeducation = 221310067,
	studio = 221310068,
	t1 = 221310069,
	t1Bis = 221310070,
	t2 = 221310071,
	t3 = 221310072,
	t4 = 221310073,
	t5 = 221310074,
	t6 = 221310075,
	t8 = 221310076,
	outside = 221310077,
	parkingBorneElectrique = 100000000,
	coloc = 100000001,
	bigFlat = 100000002,
	parkingExterieurMoto = 100000007
}

export const getLotCompleteTypeKey = (value: number) => objectGetKeys(lotCompleteTypesEnum).find((lotCompleteType) => lotCompleteTypesEnum[lotCompleteType as keyof typeof lotCompleteTypesEnum] === value)
export const getLotCompleteCategoryKey = (value: lotCompleteCategoryEnum) => objectGetKeys(lotCompleteCategoryEnum).find((lotCompleteCategory) => lotCompleteCategoryEnum[lotCompleteCategory as keyof typeof lotCompleteCategoryEnum] === value)
